import { find } from 'lodash';
import { IAddChildReferenceData } from 'src/app/shared/interfaces/form/add-child-reference-data.model';
import { convertBooleanToRadio } from '../../../shared/functions/convert-boolean-to-radio';
import { getReferenceDataById } from '../../../shared/functions/get-reference-data-by-id';
import { IReferenceData } from '../../../shared/interfaces/form/reference-data.model';
import { Location } from '../../../shared/models/location';

export class EiAddStudent {
  eiStatus: number; // TODO this needs to be ref data
  eiComment: string;
  isEITransferred: boolean;
  osisId: string;

  eiId: string;
  agency: Location;
  draftRecord: boolean;
  childFirstName: string;
  childMiddleName: string;
  childLastName: string;
  dob: Date;
  dateRefEIP: Date;
  childAddressStreet1: string;
  childAddressStreet2: string;
  childAddressCity: string;
  childAddressState: IReferenceData;
  childAddressZip: number;
  borough: IReferenceData;
  homeDistrict: IReferenceData;
  parentFirstName: string;
  parentMiddleName: string;
  parentLastName: string;
  relationship: IReferenceData;
  parentPhone: string;
  parentemail: string;
  tempHousing: string;
  parentAddressDifferent: boolean;
  parentAddressStreet1: string;
  parentAddressStreet2: string;
  parentAddressCity: string;
  parentAddressState: IReferenceData;
  parentAddressZip: string;
  parentborough: IReferenceData;
  preferredLanguage: IReferenceData;
  evaluationLanguage: IReferenceData;
  surrogateFirstName: string;
  surrogateLastName: string;
  primaryAutoEligCondition: IReferenceData;
  fosterCheck: string;
  fosterAddressDifferent: boolean;
  fosterParentAddressStreet1: string;
  fosterParentAddressStreet2: string;
  fosterParentAddressCity: string;
  fosterParentAddressState: IReferenceData;
  fosterParentAddressZip: string;
  fosterParentborough: IReferenceData;
  surrogateAssignedInEi: boolean;
  parentConsentShareCheck: string;
  childAddressSk: string;
  parentAddressSk: string;
  fosterParentAddressSk: string;
  studentSk: string;
  parentSk: string;
  fosterParentSk: string;
  documents: any;
  addedBy: string;
  addedTimeStamp: Date;
  lastModifiedBy: string;
  lastModifiedTimeStamp: Date;
  fosterCareAgency: IReferenceData;
  dateOfBirth: string | number | Date;
  parentDetails: any;

  constructor(studentData: any, referenceData: IAddChildReferenceData) {
    //TODO:We need to add types for the api endpoints, once added we need to add the types to the constructor method
    this.eiStatus = studentData.eiStatus;
    this.eiComment = studentData.eiComment;
    this.isEITransferred = studentData.isEITransferred;
    this.osisId = studentData.osisId;

    this.eiId = studentData.childEIId;
    this.agency = find(
      referenceData.agency,
      (d: Location) => d.locationKey?.toString() === studentData.agencySk
    );

    this.draftRecord = studentData.draftRecord;
    this.childAddressSk = studentData.childAddressSk;
    this.parentAddressSk = studentData.parent?.addressSk;
    this.fosterParentAddressSk = studentData.fosterParent?.addressSk;
    this.studentSk = studentData.studentSk;
    this.parentSk = studentData.parent?.parentSk;
    this.fosterParentSk = studentData.fosterParent?.parentSk;
    this.childFirstName = studentData.firstName;
    this.childMiddleName = studentData.middleName;
    this.childLastName = studentData.lastName;
    this.dob = studentData.dateOfBirth
      ? new Date(studentData.dateOfBirth)
      : null;
    this.dateRefEIP = studentData.dateOfReferralEIP
      ? new Date(studentData.dateOfReferralEIP)
      : null;
    this.childAddressStreet1 = studentData.streetAddress1?.trim();
    this.childAddressStreet2 = studentData.streetAddress2?.trim();
    this.childAddressCity = studentData.city?.trim();
    this.childAddressState = getReferenceDataById(
      studentData.state,
      referenceData.state
    );
    this.childAddressZip = studentData.zip?.trim();
    this.borough = getReferenceDataById(
      studentData.borough,
      referenceData.borough
    );
    this.homeDistrict = getReferenceDataById(
      studentData.homeDistrict,
      referenceData.homeDistrict
    );
    this.parentFirstName = studentData.parent?.firstName;
    this.parentMiddleName = studentData.parent?.middleName;
    this.parentLastName = studentData.parent?.lastName;
    this.relationship = getReferenceDataById(
      studentData.parent?.relationToChild,
      referenceData.relationships
    );
    this.parentPhone = studentData.parent?.phone;
    this.parentemail = studentData.parent?.email;
    this.tempHousing = convertBooleanToRadio(studentData.studentTempHousing);
    this.parentAddressDifferent =
      studentData.studentsJunkFields?.parentAddrDiffCheck;
    this.parentAddressStreet1 = studentData.parent?.streetAddress1?.trim();
    this.parentAddressStreet2 = studentData.parent?.streetAddress2?.trim();
    this.parentAddressCity = studentData.parent?.city?.trim();
    this.parentAddressState = getReferenceDataById(
      studentData.parent?.state,
      referenceData.state
    );
    this.parentAddressZip = studentData.parent?.zip?.trim();
    this.parentborough = getReferenceDataById(
      studentData.parent?.borough,
      referenceData.borough
    );
    this.preferredLanguage = getReferenceDataById(
      studentData.preferredLanguage,
      referenceData.languages
    );
    this.evaluationLanguage = getReferenceDataById(
      studentData.evaluationLanguage,
      referenceData.languages
    );
    this.surrogateFirstName = studentData.fosterParent?.firstName;
    this.surrogateLastName = studentData.fosterParent?.lastName;
    this.primaryAutoEligCondition = getReferenceDataById(
      studentData.eiAutoEligibleCondition,
      referenceData.eiAeConditions
    );
    this.fosterCheck = convertBooleanToRadio(
      studentData.studentsJunkFields?.fosterCheck
    );
    this.fosterAddressDifferent =
      studentData.studentsJunkFields?.fosterAddrDiffCheck;
    this.fosterParentAddressStreet1 =
      studentData.fosterParent?.streetAddress1?.trim();
    this.fosterParentAddressStreet2 =
      studentData.fosterParent?.streetAddress2?.trim();
    this.fosterParentAddressCity = studentData.fosterParent?.city?.trim();
    this.fosterParentAddressState = getReferenceDataById(
      studentData.fosterParent?.state,
      referenceData.state
    );
    this.fosterParentAddressZip = studentData.fosterParent?.zip?.trim();
    this.fosterParentborough = getReferenceDataById(
      studentData.fosterParent?.borough,
      referenceData.borough
    );
    this.surrogateAssignedInEi =
      studentData.studentsJunkFields?.surrogateAssignedCheck;
    this.parentConsentShareCheck = convertBooleanToRadio(
      studentData.studentsJunkFields?.parentConsentShareCheck
    );
    this.documents = studentData.documents;
    this.addedBy = studentData.addedBy;
    this.addedTimeStamp = studentData.addedTimeStamp;
    this.lastModifiedBy = studentData.lastModifiedBy;
    this.lastModifiedTimeStamp = studentData.lastModifiedTimeStamp;
    this.fosterCareAgency = getReferenceDataById(
      studentData.fosterCareAgency,
      referenceData.fosterAgencies
    );
  }

  get id(): string {
    return this.eiId;
  }
}
